<template>
  <v-text-field
    :rules="rules"
    @click:append="show = !show"
    v-bind="fieldProps"
    class="rounded-0 password-field"
    :append-icon="show ? 'fas fa-lock-open' : 'fas fa-lock'"
    :type="show ? 'text' : 'password'"
    placeholder="Senha"
    autocomplete="off"
    name="password"
    hide-details
    tile
    solo
  ></v-text-field>
</template>

<script>
import { requiredValidation } from "../validations/requiredValidation";
import { mixin } from "./mixin";

export default {
  data: () => ({
    show: false,
    rules: [requiredValidation("Digite sua senha.")],
  }),
  mixins: [mixin],
};
</script>

<style lang="scss" scoped>
.password-field::v-deep {
  .v-icon {
    font-size: 14px !important;
  }
}
</style>
